<div class="condition flex flex-row justify-stretch items-end">
  <div class="mr-4 text">When</div>

  <!-- Source field selector -->
  <mat-form-field class="field-autocomplete compact" appearance="outline">
    <input matInput [formControl]="fieldSearch" [matAutocomplete]="fieldAuto"
           placeholder="Select a field" tp="Select a field">
    <mat-autocomplete #fieldAuto="matAutocomplete" [displayWith]="displayField"
                      (optionSelected)="onFieldSelected($event)">
      @for (f of filteredSourceFields(); track f.field) {
        <mat-option [value]="f">{{ f.label }} ({{ f.field }})</mat-option>
      }
    </mat-autocomplete>
    @if (form.controls.source_field.invalid) {
      <mat-error>Please select a field</mat-error>
    }
  </mat-form-field>

  <!-- Operator selector -->
  <div class="operator mr-4" [matMenuTriggerFor]="operatorMenu" tp="Select an operator">
    <span>{{ form.controls.operator.valid ? readableOperator(form.controls.operator.value) : '' }}</span>
    @if (form.controls.operator.invalid) {
      <div class="invalid-value">
        <div class="error">Please select an operator</div>
      </div>
    }
    <mat-menu #operatorMenu="matMenu" yPosition="below">
      @for (o of operatorOptions; track o) {
        <button [ngClass]="{'!bg-gray-200': form.controls.operator.value === o}"
                mat-menu-item (click)="updateOperator(o)">
          @if (form.controls.operator.value === o) {
            <mat-icon fontSet="fa" fontIcon="fa-check" class="mr-2"></mat-icon>
          }
          {{ readableOperator(o) }}
        </button>
      }
    </mat-menu>
  </div>

  <!-- Comparison value editor (hidden for the "is empty" operator) -->
  @if (form.controls.operator.value !== 'blank') {
    <div class="value mr-4">
      @if (form.controls.source_field.value) {
        @switch (sourceFieldType) {
          @case (fieldTypes.BOOLEAN) {
            <mat-radio-group aria-label="Select an option" [formControl]="form.controls.value">
              <mat-radio-button value="true">True</mat-radio-button>
              <mat-radio-button value="false">False</mat-radio-button>
            </mat-radio-group>
          }
          @case (fieldTypes.DATE) {
            <mat-form-field appearance="outline" class="compact">
              <input matInput [matDatepicker]="picker" [formControl]="form.controls.value">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          }
          @case (fieldTypes.DECIMAL) {
            <mat-form-field appearance="outline" class="compact">
              <span matPrefix>$ &nbsp;</span>
              <input matInput [formControl]="form.controls.value" type="number">
            </mat-form-field>
          }
          @case (fieldTypes.INTEGER) {
            <mat-form-field appearance="outline" class="compact">
              <span matPrefix>$ &nbsp;</span>
              <input matInput [formControl]="form.controls.value" type="number">
            </mat-form-field>
          }
          @case (fieldTypes.SELECT) {
            <ng-container *ngTemplateOutlet="selectType"></ng-container>
          }
          @case (fieldTypes.RADIO) {
            <ng-container *ngTemplateOutlet="selectType"></ng-container>
          }
          @default {
            <mat-form-field appearance="outline" class="compact">
              <input matInput [formControl]="form.controls.value" type="text">
            </mat-form-field>
          }
        }
      } @else {
        <span class="no-value">Select a Field</span>
      }

      @if (form.controls.value.invalid) {
        <div class="invalid-value">
          <div class="error">Please enter a value</div>
        </div>
      } @else if (form.controls.operator.value === 'in' || form.controls.operator.value === 'none') {
        <div class="invalid-value">Separate possible values by commas</div>
      }
    </div>
  }
</div>

<ng-template #selectType>
  <mat-form-field appearance="outline" class="compact">
    @if (form.controls.operator.value !== 'in' && form.controls.operator.value !== 'none') {
      <mat-select [formControl]="form.controls.value">
        @for (o of latestOptions(form.controls.source_field.value); track o) {
          <mat-option [value]="o">{{ o }}</mat-option>
        }
      </mat-select>
    } @else {
      <mat-select [formControl]="form.controls.value" [multiple]="true">
        @for (o of latestOptions(form.controls.source_field.value); track o) {
          <mat-option [value]="o">{{ o }}</mat-option>
        }
      </mat-select>
    }
  </mat-form-field>
</ng-template>
